"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceSurveyEnum = void 0;
var SourceSurveyEnum;
(function (SourceSurveyEnum) {
    SourceSurveyEnum["SearchEngine"] = "searchEngine";
    SourceSurveyEnum["Advertisement"] = "advertisement";
    SourceSurveyEnum["Social"] = "social";
    SourceSurveyEnum["FriendOrColleague"] = "friendOrColleague";
    SourceSurveyEnum["Kobeon"] = "kobeon";
    SourceSurveyEnum["Investown"] = "investown";
    SourceSurveyEnum["Other"] = "other";
})(SourceSurveyEnum = exports.SourceSurveyEnum || (exports.SourceSurveyEnum = {}));
//# sourceMappingURL=source-survey-enum.js.map